import { isInAppBrowser } from '~/utils/device.utils';

export function useIsInAppBrowser(): boolean {
    return isInAppBrowser();
}
